import React, { forwardRef, useImperativeHandle, useState } from 'react'

import {
  ModalIncluirTesteRef,
  ModalTesteProps
} from 'src/paginas/ipgs/cursos/cadastro/componentes/tipos'

import {
  Botao,
  DataInputUnform,
  FormUnform,
  MoedaInputUnform,
  NumeroInputUnform,
  Spacer
} from '../../../../../componentes'
import { ModalBase } from '../../../../../componentes/modal-base'
import { PlanoPagamentoParcelas } from '../../../../../tipos'
import { Corpo, ContainerBotoes } from '../styles'

/** Converte dd/MM/yyyy -> Date */
function parseDataBR(dataStr: string): Date | null {
  if (!dataStr) return null
  const [dia, mes, ano] = dataStr.split('/').map(Number)
  return new Date(Date.UTC(ano, mes, dia)) // cria Date em UTC
}

/** Converte Date -> dd/MM/yyyy */
function formatarDataBR(data: Date | string): string {
  if (!data) return ''
  const d = typeof data === 'string' ? new Date(data) : data
  return d.toLocaleDateString('pt-BR')
}

const ModalEditar: React.ForwardRefRenderFunction<
  ModalIncluirTesteRef,
  ModalTesteProps
> = ({ backdrop, acaoPrimaria }, ref) => {
  const [pronto, definirPronto] = useState(false)
  const [aberta, definirAberta] = useState(false)
  const [, definirDados] = useState<PlanoPagamentoParcelas>(null)
  const [
    planoPagamento,
    definirPlanoPagamento
  ] = useState<PlanoPagamentoParcelas | null>(null)

  const fechar = () => {
    definirPronto(false)
    definirAberta(false)
  }

  const abrir = (plano: PlanoPagamentoParcelas) => {
    let dia: number, mes: number, ano: number
    const dataStr = String(plano.dataVencimento)

    if (dataStr.includes('/')) {
      // Formato dd/mm/yyyy
      const partes = dataStr.split('/')
      dia = Number(partes[0])
      mes = Number(partes[1]) - 1
      ano = Number(partes[2])
    } else if (dataStr.includes('-')) {
      // Formato yyyy-mm-dd
      const partes = dataStr.split('-')
      ano = Number(partes[0])
      mes = Number(partes[1]) - 1
      dia = Number(partes[2])
    } else {
      const d = new Date(dataStr)
      if (isNaN(d.getTime())) {
        definirPlanoPagamento({ ...plano, dataVencimento: null })
        definirPronto(true)
        definirAberta(true)
        return
      }
      dia = d.getDate()
      mes = d.getMonth()
      ano = d.getFullYear()
    }
    definirPlanoPagamento({
      ...plano,
      dataVencimento: new Date(ano, mes, dia)
    })
    definirPronto(true)
    definirAberta(true)
  }

  useImperativeHandle<ModalIncluirTesteRef, ModalIncluirTesteRef>(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = async (dados: PlanoPagamentoParcelas) => {
    const parcelaEditada: PlanoPagamentoParcelas = {
      ...planoPagamento,
      quantidade: dados.quantidade,
      valorParcela: dados.valorParcela,
      dataVencimento: dados.dataVencimento
    }

    definirDados(parcelaEditada)
    acaoPrimaria(parcelaEditada)
    fechar()
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop}>
      <Corpo>
        <h5 style={{ margin: 'auto' }}>Editar Parcela</h5>
        <Spacer padding="10px 0px" />
        {pronto && planoPagamento && (
          <FormUnform dadosIniciais={planoPagamento} acaoSucesso={acaoSucesso}>
            <NumeroInputUnform
              name="quantidade"
              max={9999}
              maxLength={4}
              label="Quantidade de parcelas"
            />
            <MoedaInputUnform name="valorParcela" label="Valor da parcela" />
            {planoPagamento?.dataVencimento && (
              <DataInputUnform
                name="dataVencimento"
                label="Data do 1º vencimento"
              />
            )}
            <Spacer padding="10px 0px" />
            <ContainerBotoes>
              <Botao
                type="button"
                id="btn-cancelar"
                texto="Cancelar"
                tema="Secundario"
                onClick={fechar}
              />
              <Botao id="btn-salvar" texto="Salvar" type="submit" />
            </ContainerBotoes>
          </FormUnform>
        )}
      </Corpo>
    </ModalBase>
  )
}

export const ModalEditarParcela = forwardRef(ModalEditar)
